import React from 'react'
import ArrowThin from '../Common/ArrowThin'
import styled from 'styled-components'

import NavbarPlusButton from '../Common/PlusButton'
import { Icon } from '../Common/CommonStyle'
import FolderView from './FolderView'
import RadioButton from '../Common/RadioButton'
import {
  NudistaMedium14,
  RobotoMedium14,
  NudistaMedium11,
  NudistaMedium9,
  NudistaSemiBold16,
  NudistaBold14,
  NudistaBoldCustomFont,
} from '../Common/Fonts'
import CreateButton from '../Common/CreateButton'

const assignments = [
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
  {
    icon: '/images/navbar/stock_profile.jpg',
    name: 'Holmes, Kate',
    id: '#NI283929123',
  },
]

const Assignments = ({
  thumbsviewNavbarMinified,
  setthumbsviewNavbarMinified,
}) => {
  return (
    <ColumnFlexDiv height='100%' gap='8px' marginTop='15px' position='relative'>
      <ColumnFlexDiv
        width={thumbsviewNavbarMinified ? '60%' : '85%'}
        marginLeft='4%'
      >
        <RowFlexDiv width='95%' alignSelf='flex-end'>
          <RowFlexDiv
            justifyContent='center'
            height='30px'
            width={thumbsviewNavbarMinified ? '0px' : '80%'}
            opacity={thumbsviewNavbarMinified ? '0' : '1'}
            zIndex={thumbsviewNavbarMinified ? '-100' : '1'}
          >
            <Icon
              width='16px'
              height='16px'
              marginBottom='5px'
              src='/images/mainView/assignmentsView/structure.svg'
            />
            <RowFlexDiv>
              <NudistaBoldCustomFont fontSize='9px' color='primary'>
                STRUCTURE CATEGORY NAME
              </NudistaBoldCustomFont>
            </RowFlexDiv>
          </RowFlexDiv>

          <ArrowThin
            width='20%'
            rotate={!thumbsviewNavbarMinified}
            onClickHandler={() => {
              console.log(
                'thumbsview bar minified is',
                thumbsviewNavbarMinified
              )
              setthumbsviewNavbarMinified(!thumbsviewNavbarMinified)
            }}
          />
        </RowFlexDiv>
      </ColumnFlexDiv>

      {/* START wiriting code for folder button from here AN */}
      <ColumnFlexDiv
        width={thumbsviewNavbarMinified ? '60%' : '85%'}
        marginLeft='2%'
      >
        <RowFlexDiv
          marginTop='5px'
          width={thumbsviewNavbarMinified ? '0px' : '100%'}
          opacity={thumbsviewNavbarMinified ? '0' : '1'}
          zIndex={thumbsviewNavbarMinified ? '-100' : '1'}
        >
          <RowFlexDiv
            height='20px'
            gap='3px'
            width={thumbsviewNavbarMinified ? '0px' : '40%'}
            opacity={thumbsviewNavbarMinified ? '0' : '1'}
            zIndex={thumbsviewNavbarMinified ? '-100' : '1'}
          >
            <Icon
              src='/images//mainView/assignmentsView/dropdown.svg'
              background-color='#6a26ca'
            />
            <RowFlexDiv width='90%'>
              <NudistaMedium14 color='lightBlack'>
                {' '}
                Display Entire Gallery
              </NudistaMedium14>
            </RowFlexDiv>

            <NudistaMedium14 color='primary'></NudistaMedium14>
          </RowFlexDiv>
          <RadioButton checkedColor='#FB8F02' />
        </RowFlexDiv>
      </ColumnFlexDiv>
      <ColumnFlexDiv
        // padding='0px 785px 0px 0px'
        // backgroundColor='#ffffff'
        width='100%'
      >
        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Uncataloged'
          backgroundColor='#ffffff'
        />
        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        {/* list of directories starts from here */}
        {/* <ColumnFlexDiv width={thumbsviewNavbarMinified ? '0px' : '100%'}>
          <ParentdirectoryLayout
            thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          />
        </ColumnFlexDiv> */}
        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />
        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />
        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />
        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />
        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />

        <FolderView
          thumbsviewNavbarMinified={thumbsviewNavbarMinified}
          title='Folder'
        />
      </ColumnFlexDiv>
      <RowFlexDiv
        backgroundColor='#123546'
        marginTop='92vh'
        width='80%'
        // marginTop='20%'
        justifyContent='center'
        alignItems='flex-end'
        marginLeft='5%'
        position='absolute'
        opacity={thumbsviewNavbarMinified ? '0' : '1'}
        zIndex='1'
      >
        <CreateButton
          // height='90%'
          backgroundColor='#123546'
          title='Create New Category'
          NavbarMinified={thumbsviewNavbarMinified}
        />
      </RowFlexDiv>
    </ColumnFlexDiv>
  )
}

const ColumnFlexDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-overflow: ellipsis;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  padding: ${(props) => props.padding};
  position: ${(props) => props.position};
  background-color: ${(props) => props.backgroundColor};
  /* background-color: #123456; */
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
`

const RowFlexDiv = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  outline: ${(props) => props.outline};
  position: ${(props) => props.position};
  padding: ${(props) => props.padding};
  top: ${(props) => props.top};
  text-overflow: ellipsis;
  white-space: nowrap;

  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  align-items: ${(props) => props.alignItems || 'center'};
  align-self: ${(props) => props.alignSelf};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  margin-left: ${(props) => props.marginLeft};
  background-color: ${(props) => props.backgroundColor};
  background: ${(props) => props.background};
  border-radius: ${(props) => props.borderRadius};
`

const Img = styled.img`
  cursor: pointer;
`

export default Assignments
